<template>
  <div>
    <!-- Tìm kiếm -->
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row">
          <i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Của hàng vi phạm</span>
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tháng:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-date-picker class="w-100" v-model="search.dThang" type="month" format="MM/YYYY" placeholder="Pick a day"
                  :size="size" />
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div style="padding-bottom: 10px; justify-content: flex-end;" class="form-row w-100 d-flex flex-row">
          <el-button plain style="margin-right:30px" title="Đồng bộ" type="warning"
            @click="handleSyncData" v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i>
          </el-button>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" fit stripe
          highlight-current-row>
            <el-table-column type="index" label="STT" align="center" width="60"></el-table-column>
            <el-table-column prop="c_ten_nguoi_bao_cao" label="Tên người báo cáo" width="250"></el-table-column>
            <el-table-column prop="c_ly_do" label="Lý do" min-width="150"> </el-table-column>
            <el-table-column label="Hình ảnh" min-width="150" align="center">
              <template #default="scope">
                <el-image :lazy="true" class="violation-img" v-if="scope.row.c_image"
                  :src="handleLoadImg(scope.row.c_image)" :preview-src-list="[handleLoadImg(scope.row.c_image)]"
                  style="height: 40px;" fit="cover" />
              </template>
            </el-table-column>
            <el-table-column prop="c_ten_cua_hang" label="Tên cửa hàng" min-width="150"></el-table-column>
            <el-table-column prop="d_ngay_tao" label="Ngày tạo" align="center" width="150">
              <template #default="scope">
                <span v-if="scope.row.d_ngay_tao">{{
                  momentDate(scope.row.d_ngay_tao)
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="warning" v-if="scope.row.n_tinh_trang == 1" :size="size">Chưa xử lý</el-tag>
                <el-tag type="danger" v-if="scope.row.n_tinh_trang == 0" :size="size">Đã từ chối</el-tag>
                <el-tag type="success" v-if="scope.row.n_tinh_trang == 2" :size="size">Đã xử lý</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { Violation } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";


export default {
  data() {
    return {
      store: useStore(),
      size: "",
      tableData: {
        content: [
        ]
      },
      search: {
        dThang: moment().startOf("month")
      },
      isSearchLoading: false,
      isLoading: false,
      centerDialogVisible: false,
      operation: false,
      productList: [],
      fit: "cover",
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      validateForm: {},
      rules: {},
      selected: {},
      answer: 1,
      feedback: "",
    };
  },
  methods: {
    handleLoadImg(val) {
      return "violation/" + val
    },

    handleSyncData() {
      this.store.dispatch(Violation.syncViolation).then(res => {
        console.log(res)
      })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        dThang: { value: moment(this.search.dThang).month() + 1 }
      }
      this.store.dispatch(Violation.findViolation,this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code == 200 && res.data)
          this.tableData = res.data;
        else
          this.tableData = []
      });
    },
    handleSizeChange(val) {
      if (typeof val != "number" && val <= 0) {
        this.pageRequest.pageSize = 30
      } else {
        this.pageRequest.pageSize = val
      }
      this.findUser();
    },
    handleCurrentChange(val) {
      if (typeof val != "number" && val <= 0) {
        this.pageRequest.pageNum = 1
      } else {
        this.pageRequest.pageNum = val
      }
      this.findUser();
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }
  },
  mounted() {
    this.handleFindPage()
  },
};
</script>
<style lang="scss" scoped>
.tbl {
  height: calc(100vh - 255px);
}

.box-card {
  margin: 10px;
}

.supply-card {
  padding: 5px;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  align-items: center;
  cursor: pointer;
}

.supply-name {
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.supply-text {
  font-size: 13px;
  margin-left: 5px;
}
</style>
<style lang="scss">
.violation-img {
  .el-image__inner {
    width: auto;
  }
}
</style>